import * as d3 from 'd3';
import { ChartDataArray } from '../data/ChartDataArray';
import { ChartDataType } from '../data/ChartDataType';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { ParallelColumnBarRenderer } from './ParallelColumnBarRenderer';

export class ParallelColumnRenderer extends ParallelColumnBarRenderer {
  constructor(gElement: d3.Selection<SVGGElement, unknown, null, undefined>) {
    super(gElement);
  }

  public render(arrays: Array<ChartDataArray>, x: d3.ScaleBand<string>, y: d3.ScaleLinear<number, number>) {
    const breakdownData = arrays.filter(dataArray => dataArray.type === ChartDataType.breakdown);
    const primaryData = arrays.find(dataArray => dataArray.type === ChartDataType.primary && !dataArray.isComparison);
    // build breakdownSeries, group by key
    const breakdownSeries = super.createBreakdownSeriesParallel(breakdownData);

    // scale for breakdown groups
    const xBreakdown: d3.ScaleBand<number> = d3
      .scaleBand<number>()
      .domain(d3.range(breakdownSeries.length))
      .range([5, x.bandwidth() - 5]);

    const zeroY = y(0);

    const handlers: ColumnBarChartAttrHandler = {
      x: (_, i) => x(primaryData!.data[i].label!)!,
      y: d => Math.min(y(d.value), zeroY),
      width: () => xBreakdown.bandwidth(),
      height: d => Math.abs(zeroY - y(d.value)),
      transform: (_, i) => `translate( ${xBreakdown(i)} ,0)`,
    };

    super.renderInternal(breakdownSeries, handlers);
  }
}
